import { Component, inject, OnInit } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule, ValidationErrors, ValidatorFn,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
    MAT_DIALOG_DATA,
    MatDialogContent,
    MatDialogModule,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { Person } from '../../classes/person.class';
import { DaysKey, IScheduleParams } from '../../typing/schedule-params.interface';

@Component({
    selector: 'app-schedule-params',
    standalone: true,
    imports: [
        FormsModule,
        MatButton,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogModule,
    ],
    templateUrl: 'schedule-params.component.html',
    styleUrls: ['./schedule-params.component.scss']
})

export class ScheduleParamsComponent implements OnInit{
    public person: Person = inject(MAT_DIALOG_DATA);
    protected readonly parseInt = parseInt;
    protected readonly Object = Object;
    public scheduleForm!: FormGroup;
    readonly dialogRef = inject(MatDialogRef<ScheduleParamsComponent>);
    readonly fb = inject(FormBuilder);
    scheduleValues:IScheduleParams = {
        1 : {startWorkTime: null, endWorkTime: null, startLunchTime: null, endLunchTime: null},
        2 : {startWorkTime: null, endWorkTime: null, startLunchTime: null, endLunchTime: null},
        3 : {startWorkTime: null, endWorkTime: null, startLunchTime: null, endLunchTime: null},
        4 : {startWorkTime: null, endWorkTime: null, startLunchTime: null, endLunchTime: null},
        5 : {startWorkTime: null, endWorkTime: null, startLunchTime: null, endLunchTime: null},
        6 : {startWorkTime: null, endWorkTime: null, startLunchTime: null, endLunchTime: null},
        7 : {startWorkTime: null, endWorkTime: null, startLunchTime: null, endLunchTime: null},
    };

    daysOfTheWeek = [ null,'Понедельник','Вторник','Среда','Четверг','Пятница','Суббота','Воскресенье'];
    applyToAll = false;

    //валидатор для полей времени
    timeValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {

            let requireWorkTimes = false;
            let requireLunchTimes = false;
            let requireTimes = false;

            // Перебираем все дни недели
            for (const day in (control as FormGroup).controls) {
                if (Object.prototype.hasOwnProperty.call((control as FormGroup).controls, day)) {
                    const dayFormGroup = (control as FormGroup).get(day) as FormGroup;

                    const startWorkTime = dayFormGroup.get('startWorkTime')?.value;
                    const endWorkTime = dayFormGroup.get('endWorkTime')?.value;
                    const startLunchTime = dayFormGroup.get('startLunchTime')?.value;
                    const endLunchTime = dayFormGroup.get('endLunchTime')?.value;
                    const workDay = dayFormGroup.get('workDay')?.value;

                    if (workDay) {
                        if (!(startWorkTime && endWorkTime)){
                            requireTimes = true;
                        }

                        if ((startWorkTime || endWorkTime) && !(startWorkTime && endWorkTime)) {
                            requireWorkTimes = true;
                        }

                        if ((startLunchTime || endLunchTime) && !(startLunchTime && endLunchTime)) {
                            requireLunchTimes = true;
                        }
                    }
                }
            }

            const errors: ValidationErrors = {};
            if (requireTimes){
                errors['requireTimes'] = true;
            }
            if (requireWorkTimes) {
                errors['requireWorkTimes'] = true;
            }
            if (requireLunchTimes) {
                errors['requireLunchTimes'] = true;
            }

            return Object.keys(errors).length ? errors : null;
        };
    }

    ngOnInit(): void {
        if ( this.person.data.scheduleParams ) {
            this.scheduleValues = this.person.data.scheduleParams;
        }
        this.createSchedule();
    }

    createSchedule(): void {
        const formGroup:{ [key: number]: FormGroup } = {};
        Object.keys(this.scheduleValues).forEach((day) => {
            const dayKey = parseInt(day) as DaysKey;
            const isWorkDay = this.scheduleValues[dayKey] !== null;

            const scheduleDay = isWorkDay ? {
                startWorkTime: [this.scheduleValues[dayKey]?.startWorkTime],
                endWorkTime: [this.scheduleValues[dayKey]?.endWorkTime],
                startLunchTime: [this.scheduleValues[dayKey]?.startLunchTime],
                endLunchTime: [this.scheduleValues[dayKey]?.endLunchTime],
                workDay: true,
            }
                : {
                    startWorkTime: null,
                    endWorkTime: null,
                    startLunchTime: null,
                    endLunchTime: null,
                    workDay: false,
                };

            const group = this.fb.group(scheduleDay);
            formGroup[dayKey] = group;
        });

        this.scheduleForm = this.fb.group(formGroup, {
            validators: this.timeValidator(),
        });
    }

    selectApplyToAll(): void {
        if (!this.applyToAll) {return;}

        const daySchedule =  this.scheduleForm.get('1')?.value;
        if (!daySchedule) {return;}

        Object.entries(this.scheduleValues).forEach(([day]) => {
            const dayKey = parseInt(day) as DaysKey;
            if (dayKey === 1) {return;}

            this.scheduleForm.get(dayKey.toString())?.patchValue({
                startWorkTime: daySchedule.startWorkTime,
                endWorkTime: daySchedule.endWorkTime,
                startLunchTime: daySchedule.startLunchTime,
                endLunchTime: daySchedule.endLunchTime,
            });
        });
    }

    submit():void {
        // Обновляем scheduleValues из формы
        Object.keys(this.scheduleValues).forEach((day) => {
            const dayKey = parseInt(day) as DaysKey;

            const formValue = this.scheduleForm.get(dayKey.toString())?.value;

            this.scheduleValues[dayKey] = formValue.workDay ? {
                startWorkTime: formValue?.startWorkTime,
                endWorkTime: formValue?.endWorkTime,
                startLunchTime: formValue?.startLunchTime,
                endLunchTime: formValue?.endLunchTime,
            } : null;
        });
        this.person.data.scheduleParams = this.scheduleValues;
        this.dialogRef.close();
    }

    close(): void {
        this.dialogRef.close();
    }
}
